<template>
	<div class="kf_course">
		<h1 class="title">科飞课堂</h1>
		<h2 class="en_title">CLASSROOM</h2>
		<div class="items clear_both">
			<a v-for="v in list" :key="v.courseId" class="item" @click="handleItemClick(v)">
				<div class="course_img">
					<img :src="v.picOssUrl" alt="">
				</div>
				<p class="course_name text_one">{{ v.courseName }}</p>
			</a>
		</div>
		<div class="btn"><button @click="toKfCourse">More</button></div>
	</div>
</template>

<script>
	export default {
		props: {
			list: {
				type: Array,
				default() { return []; }
			}
		},
		methods: {
			/*************** @Events *******************/
			// 点击视频
			handleItemClick(obj) {
				this.$emit('onClick', obj.courseId);
			},
			// 跳到科飞课堂
			toKfCourse() {
				window.open('http://ke.uflyvision.com/');
			}
		}
	}
</script>

<style scoped>
	.kf_course{ width: 1200px;margin: 50px auto 0; }
	.kf_course .title{ font-size: 30px;font-weight: bold;text-align: center;line-height: 42px; }
	.kf_course .en_title{ font-size: 24px;color: #ccc;text-align: center;line-height: 34px; }
	.kf_course .items{ margin-top: 40px; }
	.kf_course .item{ display: block;float: left;width: 360px;margin: 0 60px 42px 0; }
	.kf_course .item:nth-child(3n){ margin-right: 0; }
	.kf_course .course_img{ height: 228px;overflow: hidden; }
	.kf_course .course_img img{ display: block;width: 100%;height: 100%;transition: all .3s linear; }
	.kf_course .course_img:hover img{ transform: scale(1.2, 1.2); }
	.kf_course .course_name{ padding: 0 10px;font-size: 18px;color: #2a2a2a;text-align: center;line-height: 46px; }
	.kf_course .btn{ margin-top: 10px;text-align: center; }
	.kf_course .btn button{ padding: 0 40px;line-height: 38px; }
</style>
